module.exports = __webpack_public_path__ + "img/Group 6858.89c64b60.png";